"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskTemplateInputType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.TaskTemplateInputType = {
    CONSTANT: 'CONSTANT',
    PRODUCT_TEMPLATE: 'PRODUCT_TEMPLATE',
    DATASET_PAIRS: 'DATASET_PAIRS',
    INPUT_INDEXED_DATASETS: 'INPUT_INDEXED_DATASETS',
    INPUT_NAMED_DATASET: 'INPUT_NAMED_DATASET',
    INPUT_NAMED_CATEGORY: 'INPUT_NAMED_CATEGORY',
    OUTPUT_INDEXED_DATASETS: 'OUTPUT_INDEXED_DATASETS',
    OUTPUT_NAMED_DATASET: 'OUTPUT_NAMED_DATASET',
    OUTPUT_NAMED_CATEGORY: 'OUTPUT_NAMED_CATEGORY',
    FREESTYLE_JSON: 'FREESTYLE_JSON',
    COMMENT: 'COMMENT'
};
//# sourceMappingURL=task-template-input-type.js.map